/**
 * Catch-all for customer/cashier users who hit the web — direct them
 * back to the mobile app.
 */
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth';

export default function MobileOnlyPage() {
  const navigate = useNavigate();
  const { user, signOut } = useAuthStore();
  const onLogout = () => {
    signOut();
    navigate('/login', { replace: true });
  };
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-4 relative">
      <div className="absolute inset-x-0 top-0 h-[420px] bg-gradient-to-b from-gold/15 to-transparent pointer-events-none" />
      <div className="relative w-full max-w-lg text-center" data-testid="mobile-only">
        <img
          src="/onestamp-logo.png"
          alt="OneStamp"
          className="w-28 h-28 mx-auto rounded-2xl shadow-glow-gold-sm"
        />
        <p className="font-display mt-5 text-base italic text-gold tracking-wide">
          One Card. One Tap. One Connection.
        </p>
        <h1 className="font-display mt-6 text-3xl font-bold tracking-tight">
          This experience lives on mobile
        </h1>
        <p className="mt-4 text-white/55">
          OneStamp customer and cashier features are mobile-only. Please use
          the iOS / Android app to continue.
        </p>
        {user ? (
          <p className="mt-6 text-sm text-white/40">
            Signed in as {user.email} ({user.role})
          </p>
        ) : null}
        <button
          onClick={onLogout}
          data-testid="mobile-only-logout"
          className="mt-8 px-6 py-3 rounded-2xl border border-gold/30 text-gold hover:bg-gold/10 hover:shadow-glow-gold-sm transition"
        >
          Log out
        </button>
      </div>
    </div>
  );
}
